<script setup lang="ts">
  import { cn } from '@ui/utils/utils';

  defineProps<{ healthy: boolean }>();
</script>

<template>
  <div class="grid grid-cols-[1fr_20px] gap-x-8">
    <p class="text-2xs">
      <slot />
    </p>

    <i
      :class="
        cn(
          'far text-xs text-center',
          healthy ? 'fa-check text-success' : 'fa-times text-destructive',
        )
      "
    />
  </div>
</template>

<style scoped></style>
